import{Routes}from'@angular/router';
export const routes:Routes=[
  {path:'stand',loadChildren:()=>import('./stand/stand.routes').then(m=>m.STAND_ROUTES)},
  {path:'tv',loadChildren:()=>import('./tv/tv.routes').then(m=>m.TV_ROUTES)},
  {path:'pair',loadComponent:()=>import('./stand/pair/pair.component').then(m=>m.PairComponent)},
  {path:'',redirectTo:'stand',pathMatch:'full'}
];
